import Swiper from 'swiper';
import detectMobile from '@/scripts/utils/detect-mobile';

export default function () {
  $('[data-type="two-halves-slider-image"]').each((i, el) => {
    const $this = $(el);
    const $btnPrev = $this.find('[data-type="button-prev"]');
    const $btnNext = $this.find('[data-type="button-next"]');
    const swiperConfig = {
      loop: true,
      effect: 'slide',
      spaceBetween: 5,
      speed: 600,
      autoHeight: true,
      centeredSlides: true,
      navigation: {
        nextEl: $btnNext,
        prevEl: $btnPrev,
      },
      breakpoints: {
        1024: {
          effect: 'slide',
          slidesPerView: 2,
          spaceBetween: 30,
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 15,
        },
      },
    };

    const $images = $this.find('[data-type="two-halves-slider-images"]');

    if (!$images.length) return;

    $($images).each((k, elem) => {
      const slider = new Swiper($(elem), swiperConfig);
      if (detectMobile()) {
        slider.autoplay.start();
      }
    });
  });
}




// WEBPACK FOOTER //
// ./scripts/blocks/two-halves-img-slider.js